import api from './api'
import BaseService from './BaseService'

const DEFAULT = {
  title: '推荐给你一个不错的福音APP',
  desc: 'MFUYIN.TV\n福音影视网\n扎根基督 服侍教会',
  link: 'https://' + getHost(),
  imgUrl: `https://${getHost()}/static/logo.png`
}

function getHost() {
  return window.location.host
}

export default class WechatService extends BaseService {
  async getJsSign() {
    let url = window.location.href
    let index = url.indexOf('#')
    if (index >= 0) {
      url = url.substr(0, index)
    }
    return await api.other.getJsSign({
      url
    })
  }

  sign(params) {
    return new Promise(async (resolve, reject) => {
      try {
        let result = await this.getJsSign()
        window.wx.config({
          debug: !!params.debug,
          appId: result.appId,
          timestamp: result.timestamp,
          nonceStr: result.nonceStr,
          signature: result.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        window.wx.ready(() => {
          this.ready = true
          this.callShare(this.lastShare)
        })
        resolve()
      } catch (err) {
        reject(err)
      }
    })
  }

  callShare(info) {
    if (this.ready) {
      info = Object.assign({}, DEFAULT, info)
      window.wx.onMenuShareTimeline(info)
      window.wx.onMenuShareAppMessage(info)
    } else {
      this.lastShare = info
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/WechatService.js